import AnimetaTransition from './AnimetaTransition.vue'
import AnimetaTransitionGroup from './AnimetaTransitionGroup.vue'

export default {
  AnimetaTransition,
  AnimetaTransitionGroup
}
